export const gstCodes: Record<string, number> = {
    'GST': 0.1,
    'CAP': 0.1,
    'FREE': 0.0,
    'CAPF': 0.0,
    'EXEMPT': 0.0,
    'N-T': 0.0
};